import { assign, DoneInvokeEvent, send, StateNodeConfig } from "xstate";

import { uploadFile } from "@/tools/msa/processing/extraction/legacy";
import { Response } from "@/tools/msa/models/requests/extraction/legacy";
import { processResults } from "@/tools/msa/processing/extraction/modern";

export const extractionStates: StateNodeConfig<any, any, any> = {
  initial: "selected",
  states: {
    selected: {
      entry: assign({
        file: (context, event: Record<"file", File>) => event.file
      }),
      on: {
        UPLOAD: "uploading",
        SELECT: "selected"
      }
    },
    uploading: {
      entry: assign({ step: (context, event) => 2 }),
      invoke: {
        src: uploadFile,
        onDone: [
          {
            target: "extracted",
            actions: assign({
              sessionId: (context, event) => event.data.sessionId,
              response: (context, event) => event.data.results,
              retries: () => 0
            }),
            cond: (context, event) => event.data.cached
          },
          {
            target: "processing",
            actions: assign({
              sessionId: (context, event) => event.data.sessionId,
              jobId: (context, event) => event.data.jobId,
              retries: () => 0
            })
          }
        ],
        onError: [
          {
            target: "uploading",
            actions: assign({ retries: context => context.retries + 1 }),
            cond: context => context.retries === 0
          },
          { target: "failed" }
        ]
      }
    },
    processing: {
      entry: assign({ step: (context, event) => 3 }),
      invoke: {
        src: processResults,
        onDone: [
          {
            target: "extracted",
            actions: [
              (context, event) => console.log(context, event),
              assign({
                response: (context, event) => event.data,
                retries: () => 0
              })
            ],
            cond: (context, event: DoneInvokeEvent<Response>) =>
              event.data.outcome === "success"
          },
          {
            target: "pending",
            actions: assign({
              retries: () => 0
            }),
            cond: (context, event: DoneInvokeEvent<Response>) =>
              event.data.outcome === "error" &&
              event.data.type === "invalid_status" &&
              event.data.status === "IN_PROGRESS"
          }
        ],
        onError: [
          {
            target: "processing",
            actions: assign({ retries: context => context.retries + 1 }),
            cond: context => context.retries === 0
          },
          { target: "failed" }
        ]
      }
    },
    pending: {
      after: {
        15000: "processing"
      }
    },
    extracted: {
      entry: send("PROCESS")
    },
    failed: {
      entry: send((context, event) => ({ type: "FAILED", data: event.data }))
    }
  }
};
